import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// --- YENİ EKLENEN KISIM: Service Worker Kaydı ---
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // public klasöründeki firebase-messaging-sw.js dosyasını kaydediyoruz
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Service Worker başarıyla kaydedildi:", registration.scope);
      })
      .catch((error) => {
        console.error("Service Worker kaydı başarısız oldu:", error);
      });
  });
}
